import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//添加以下代码
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    name: '登录',
    component: () => import(/* webpackChunkName: "about" */ '../views/login.vue')
  },
  {
    path: '/forgotpassword',
    name: '忘记密码',
    component: () => import(/* webpackChunkName: "about" */ '../views/wj.vue')
  }, {
    path: '/register',
    name: '注册',
    component: () => import(/* webpackChunkName: "about" */ '../views/register.vue')
  },
  {
    path: '/index',
    name: '首页',
    component: () => import(/* webpackChunkName: "about" */ '../views/index.vue'),
    meta: { requireAuth: true },
    children: [{
      path: 'relation', //关联账户
      component: () => import('../views/my/relation.vue'),
      meta: { requireAuth: true },

    }, {
      path: 'documentary', //同步管理
      component: () => import('../views/my/documentary.vue'),
      meta: { requireAuth: true },

    }, {
      path: 'SiganlAdmin', //信号管理
      component: () => import('../views/my/SignalAdmin.vue'),
      meta: { requireAuth: true },

    }, {
      path: 'admin', //信号管理
      component: () => import('../views/my/admin.vue'),
      meta: { requireAuth: true },

    }, {
      path: 'indexPage', //首页
      component: () => import('../views/my/indexPage.vue'),
      meta: { requireAuth: true },

    }, {
      path: 'SignalDetails', //信号池
      component: () => import('../views/my/SignalDetails.vue'),
      meta: { requireAuth: true },

    }, {
      path: 'SDdetails', //信号池
      component: () => import('../views/my/SDdetails.vue'),
      meta: { requireAuth: true },

    }, {
      path: 'OperationManual', //操作手册
      component: () => import('../views/my/OperationManual.vue'),
      meta: { requireAuth: true },

    },
    {
      path: 'vip', //会员购买
      component: () => import('../views/vip.vue'),
      meta: { requireAuth: true },

    },{
      path: 'wallet', //钱包
      component: () => import('../views/wallet.vue'),
      meta: { requireAuth: true },

    },
    {
      path: 'team', //团队
      component: () => import('../views/my/team.vue'),
      meta: { requireAuth: true },

    },
    ]
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
